export default "__VITE_ASSET__CNzxy7bB__"